import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { TPaginationInfo, TUserPaginationOption } from '@monorepo/types';
import { isEqual } from 'lodash';
import { TdropdownItems } from '../dropdown/dropdown.types';
import { PopoverController } from '@ionic/angular';
import { DropdownComponent } from '../dropdown/dropdown.component';

@Component({
  selector: 'monorepo-mobile-listing-pagination',
  templateUrl: './mobile-listing-pagination.component.html',
  styleUrls: ['./mobile-listing-pagination.component.scss'],
})
export class MobileListingPaginationComponent implements OnInit {
  @Input() itemsPerPage: number[] = [10, 20, 30];
  @Input() paginationInfo!: TPaginationInfo;
  @Input() set paginationOption(v: TUserPaginationOption) {
    if (v && !isEqual(v, this.userPaginationOption)) {
      this.userPaginationOption = v;
    }
  }

  @Output() updateUserPaginationTuple = new EventEmitter<TUserPaginationOption>();

  userPaginationOption: TUserPaginationOption = {
    pageNo: 1,
    pageSize: 10,
  };
  isItemsPerPageCountDropdownOpen = false;

  constructor(private popoverController: PopoverController) {}

  ngOnInit(): void {
    if (!this.paginationInfo) {
      throw new Error('paginationInfo is required for MobileListingPaginationComponent');
    }
  }

  async openItemsPerPageDropdown(event: Event) {
    if (this.paginationInfo.totalItems === 0) return;
    this.isItemsPerPageCountDropdownOpen = true;
    const items: TdropdownItems<number> = this.itemsPerPage.map((itemPerPage) => ({
      type: itemPerPage,
      displayText: itemPerPage.toString(),
      backgroundColor: this.userPaginationOption.pageSize === itemPerPage ? '#eff2fe' : '',
    }));

    const popover = await this.popoverController.create({
      component: DropdownComponent,
      event,
      animated: true,
      showBackdrop: true,
      alignment: 'center',
      cssClass: 'mobile-listing-pagination-popover',
      componentProps: { items },
    });
    await popover.present();
    popover.onDidDismiss().then((val) => {
      this.isItemsPerPageCountDropdownOpen = false;
      if (val.data) this.#changeItemsPerPage(val.data);
    });
  }

  #changeItemsPerPage(itemsPerPage: number) {
    if (itemsPerPage !== this.userPaginationOption.pageSize) {
      this.userPaginationOption = {
        pageNo: 1,
        pageSize: itemsPerPage,
      };
      this.#emitUserPaginationTuple();
    }
  }

  #emitUserPaginationTuple() {
    this.updateUserPaginationTuple.emit(this.userPaginationOption);
  }

  private updatePage(newPage: number): void {
    if (newPage >= 1 && newPage <= this.paginationInfo.totalPageCount) {
      this.userPaginationOption = {
        ...this.userPaginationOption,
        pageNo: newPage,
      };
      this.#emitUserPaginationTuple();
    }
  }

  onPrevious(): void {
    this.updatePage(this.userPaginationOption.pageNo - 1);
  }

  onNext(): void {
    this.updatePage(this.userPaginationOption.pageNo + 1);
  }
}
